//Hooks
import { get } from 'svelte/store';
//Formating
import { format } from 'svelte-i18n';
//Helpers
import { is_gen_2, real_id } from 'src/helpers/interface_helpers';
import { getVirtualComponentsActions } from '../../webhooks/core/webhook_virtual_helpers';
// Stores
import { devices_settings, devices_status } from 'src/stores/device-runtime/status';
import { isVirtualDevice } from 'src/helpers/virtual_helpers/virtual_components_helpers';
//Types
import type { Device } from 'src/types/Device';
import type { WebHooksParams } from 'src/types/requests/settings/webhooks';
import type { ActionJob, LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

export const doesSupportVirtualLocalActions = (device: Device, job: ActionJob = null): boolean => {
	const id = real_id(device.id);
	let vComponents: string[] = [];
	if (isVirtualDevice(device.type)) {
		const deviceStatus = devices_status.getByRealId(id);
		const group = `group:${device.channel}`;
		vComponents = deviceStatus?.[group]?.value || [];
	} else if (is_gen_2(device)) {
		const deviceSetting = devices_settings.getByRealId(device.id);
		vComponents = Object.keys(deviceSetting || {});
	}
	if (job) {
		const method = (job?.method || '').split('.')[0].toLowerCase();
		return vComponents.find((key) => key == `${method}:${job.params?.id}`) != null;
	}
	return vComponents.find((key) => /^(boolean|enum|text|button|number):2\d{2}$/.test(key)) != null;
};

export const getVirtualLocalControlOptions = (
	action: ActionJob,
	device: Device,
): LocalControlOptions => {
	const $format = get(format);
	const deviceSetting = devices_settings.getByRealId(device.id);
	const virtualComponents = Object.keys(deviceSetting || {})
		.filter((key) => /^(boolean|enum|text|button|number):2\d{2}$/.test(key))
		.sort();

	let localControlOptions: LocalControlOptions = {
		title: $format('local_action_virtual_components_actions', {
			default: 'Virtual Components Actions',
		}),
		value: '',
		params: {},
		attr: {},
		virtual: {
			selected: null,
			options: [],
		},
	};
	const localActions: WebHooksParams['components'] = getVirtualComponentsActions(
		virtualComponents,
		deviceSetting,
	);
	for (let i = 0; i < localActions.length; ++i) {
		const localAction = localActions[i];
		const method =
			`${localAction.type}.${localAction.type == 'button' ? 'trigger' : 'set'}`.toLowerCase();
		let value: any = '';
		let event: string = '';
		switch (localAction.type) {
			case 'number':
				value = 0;
				break;
			case 'text':
			case 'enum':
				value = '';
				break;
			case 'boolean':
				value = false;
				break;
			case 'button':
				event = 'single_push';
				break;
		}
		value = localAction?.config?.default_value != null ? localAction.config.default_value : value;
		const option: LocalControlOptions = {
			title: localAction?.title,
			value: `${method}:${localAction.cid}`,
			attr: { [`${localAction.type == 'button' ? 'event' : 'value'}`]: true },
			params: {
				id: Number(localAction.cid),
				value: localAction.enums ? localAction.enums[0].value : value,
				event: localAction.enums ? localAction.enums[0].value : event,
			},
			config: localAction?.config,
			role: localAction?.role,
			icon: localAction.icon,
			enums: localAction.enums,
			unit: localAction.unit,
		};
		localControlOptions.virtual.options.push(option);
		const selected =
			method == (action.method || '').toLowerCase() && action.params?.id == localAction.cid;
		if (i == 0 || selected) {
			if (selected) {
				if (localAction.type == 'button' && action.params?.event != null) {
					option.params.event = action.params.event;
				} else if (action.params?.value != null) {
					option.params.value = action.params.value;
				}
			}
			localControlOptions = {
				...option,
				...localControlOptions,
				value: method,
			};
			localControlOptions.params.id = localAction.cid;
			localControlOptions.virtual.selected = option;
		}
	}
	return localControlOptions;
};
